import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var fog = createRuntimeFn({defaultClassName:'fx_e395032e_wytd9v4',variantClassNames:{side:{top:'fx_e395032e_wytd9v5',bottom:'fx_e395032e_wytd9v6',right:'fx_e395032e_wytd9v7',left:'fx_e395032e_wytd9v8'}},defaultVariants:{},compoundVariants:[]});
var fogBackgroundColorVar = 'var(--fx_e395032e_wytd9v3)';
var scrollbar = 'fx_e395032e_wytd9v1';
var thumb = 'fx_e395032e_wytd9v2';
var viewport = 'fx_e395032e_wytd9v0';

export { fog, fogBackgroundColorVar, scrollbar, thumb, viewport };
//# sourceMappingURL=scrollArea.vanilla.mjs.map
